import { render, staticRenderFns } from "./ProCustomers.vue?vue&type=template&id=065e3b42&"
import script from "./ProCustomers.vue?vue&type=script&lang=js&"
export * from "./ProCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports